import { render, staticRenderFns } from "./SendOpportunityAlerts.vue?vue&type=template&id=6b3bd2b6&scoped=true"
import script from "./SendOpportunityAlerts.vue?vue&type=script&lang=js"
export * from "./SendOpportunityAlerts.vue?vue&type=script&lang=js"
import style0 from "./SendOpportunityAlerts.vue?vue&type=style&index=0&id=6b3bd2b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3bd2b6",
  null
  
)

export default component.exports